import { StatusIcon } from '@/components/sv/status-icon'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import type { DatabaseStatus } from '@/graphql.types'
import type { FC } from 'react'

const tooltipMap: Record<DatabaseStatus | 'suspended', string> = {
  creating: 'Database is being created',
  dbDeletionFailed: 'Database deletion failed',
  deleting: 'Database is being deleted',
  error: 'Database error',
  passwordChange: 'Password is being changed',
  passwordChangeFailed: 'Password change failed',
  ready: 'Database is ready',
  restoring: 'Database is being restored',
  restoringFailed: 'Database restore failed',
  updating: 'Database is being updated',
  updatingExternalConnection: 'Updating external connection',
  suspended: 'Database is suspended',
}

type Props = {
  status?: DatabaseStatus | 'suspended'
}

export const DatabaseStatusIcon: FC<Props> = ({ status }) => {
  if (!status) {
    return null
  }
  const tooltip = tooltipMap[status]
  return (
    <Tooltip>
      <TooltipTrigger asChild className="cursor-pointer">
        <div>
          <StatusIcon status={status} />
        </div>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}
